import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { DatabaseBackup, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { saveBlob } from "@/components/payroll/bankUtils";

export default function BackupPanel() {
  const [withFiles, setWithFiles] = useState(false);
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);
  const loadLast = () => api.get("/admin/backup/last").then((r) => setLast(r.data.last)).catch(() => {});
  useEffect(() => { loadLast(); }, []);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/admin/backup?include_files=${withFiles}`, { responseType: "blob", timeout: 0 });
      saveBlob(r, "akat_yedek.zip");
      toast.success("Yedek indirildi");
      loadLast();
    } catch { toast.error("Yedek alınamadı, tekrar deneyin"); } finally { setBusy(false); }
  };
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-lg p-4" data-testid="backup-panel">
      <div className="flex items-center gap-2 mb-1"><DatabaseBackup size={16} className="text-slate-700" /><h4 className="font-semibold text-sm">Yedek Al</h4></div>
      <p className="text-xs text-slate-600 mb-3">Tüm veriler (geri yüklenebilir tam kopya) ve Excel ile açılabilen personel, avans, bordro ve izin tabloları tek ZIP dosyasında iner.</p>
      <label className="flex items-center gap-2 text-sm mb-3 cursor-pointer">
        <input type="checkbox" checked={withFiles} onChange={(e) => setWithFiles(e.target.checked)} data-testid="backup-include-files" />
        SGK bildirgeleri ve imzalı makbuzları da ekle <span className="text-[11px] text-slate-500">(dosya büyür, indirme uzayabilir)</span>
      </label>
      <div className="flex items-center gap-3 flex-wrap">
        <button type="button" onClick={run} disabled={busy} data-testid="backup-download"
          className="inline-flex items-center gap-2 px-4 py-2 bg-slate-900 hover:bg-slate-800 text-white rounded-lg text-sm font-semibold disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <DatabaseBackup size={14} />} {busy ? "Hazırlanıyor..." : "Yedeği İndir"}
        </button>
        {last && (
          <span className="text-[11px] text-slate-500" data-testid="backup-last">
            Son yedek: {new Date(last.at).toLocaleString("tr-TR")} · {last.by}{last.include_files ? " · dosyalar dahil" : ""}
          </span>
        )}
      </div>
    </div>
  );
}
